import { useCallback } from "react";
import { TextField } from "@mui/material";
import { translate } from "../../utils/translate";
import clsx from "clsx";
import css from "../../css/modules/toolbar.module.scss";

export function SearchTask({ api }) {
  const onFindTask = useCallback(
    (e) => {
      let value = e.target.value;
      const gantt = api.gantt;

      gantt.taskStore.removeFilter('SearchBarNameFilter');

      if (value !== "") {
        value = value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

        gantt.taskStore.filter({
          filters: {
            id: 'SearchBarNameFilter',
            filterBy: (task) => task.name && task.name.match(new RegExp(value, "i"))
          },
          replace: false
        });
      }
    },
    [api]
  );
  return (
    <TextField
      variant="outlined"
      label={translate("Find tasks by name")}
      onChange={onFindTask}
      className={clsx(css.formControl, css.input)}
      data-testid="tb_search_task"
    />
  );
}
